module.exports = __webpack_public_path__ + "img/槲寄生.6b4e978a.jpg";